<template>
  <div class="dm-list-wrap" :class="{ mobile: mobile }">
    <div class="search-message-input">
      <span class="material-icons">search</span>
      <input
        type="text"
        v-model="searchMessageText"
        @input="searchDMList"
        :placeholder="$t('chat.searchMessagesPlaceholder')"
      />
    </div>
    <div class="list-wrap" v-if="chatsToDisplay.length > 0">
      <div
        class="list-item"
        v-for="dm in chatsToDisplay"
        :key="dm.id"
        @click="selectDM(dm)"
      >
        <div class="dm-icon-wrap">
          <div class="img-wrap">
            <img
              class="frame"
              :src="
                imageBaseUrl +
                'api/users/' +
                'pictureframe?rol_id=' +
                dm.rol_id +
                '&type=circle' +
                '&sid=' +
                sid
              "
              alt=""
            />
            <img draggable="false" :src="dm.imageURL" />
          </div>
          <div class="green-dot" v-if="dm.online"></div>
        </div>
        <div class="dm-name-and-last-message">
          <div class="unseen-msg" v-if="dm.unseenMsgs">{{ dm.unseenMsgs }}</div>
          <span class="name-lastname" v-if="dm">
            {{ nameLastnameTitle(dm) }}
            <span class="name-title">{{ dm.title }}</span>
          </span>
          <span
            class="name-message"
            v-if="dm.lastMessageSender && dm.lastMessage"
            >{{ dm.lastMessageSender + ": " + dm.lastMessage }}</span
          >
          <span class="name-message" v-else>{{ $t("chat.noMessages") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const TRANSLATIONS = {
  š: 's',
  č: 'c',
  ć: 'c',
  đ: 'dj',
  ž: 'z',
};
import { mapState } from 'vuex'
import api from "../../api";
export default {
  data() {
    return {
      chats: [],
      chatsToDisplay: [],
      searchMessageText: "",
      searchTimer: null,
      refreshTimer: null,
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    };
  },
  computed: {
    ...mapState(['rol_id']),
    sid() {
      return localStorage.getItem('sid')
    },
  },
  mounted() {
    this.startRefresh();
    this.postEventTracking({ code: "booth_live_chat", data:"" })
  },
  beforeDestroy() {
    this.stopRefresh();
  },
  props: {
    gotoprofile: Number,
    orientation: Boolean,
    mobile: Boolean,
  },
  watch: {
    gotoprofile: {
      handler() {
        this.getDMs();
      },
    },
  },
  methods: {
    nameLastnameTitle(dm) {
      let text = "";
      let name = dm.name;
      let lastname = dm.lastname;
      let title = dm.title;
      if (name) text += name;
      if (lastname) text += " " + lastname;
      if (title) text += ", ";
      return text;
    },
    searchDMList() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchTimer = setTimeout(() => {
        this.filterPeople();
      }, 700);
    },
    filterPeople() {
      let text = this.searchMessageText;
      this.chatsToDisplay = this.chats.filter((item) => {
        let nameLastname = item.name + " " + item.lastname;
        nameLastname = nameLastname.toLowerCase();
        for (const specChar in TRANSLATIONS) {
          if (nameLastname.includes(specChar) && !text.includes(specChar)) {
            nameLastname = nameLastname.split(specChar).join(TRANSLATIONS[specChar]);
            text = text.split(specChar).join(TRANSLATIONS[specChar]); 
          }
        }
        text = text.toLowerCase();
        if (nameLastname.includes(text)) {
          return item;
        }
      });
    },
    startRefresh() {
      this.stopRefresh();
      this.getDMs();
      this.refreshTimer = setInterval(() => {
        this.getDMs();
      }, 3 * 1000);
    },
    stopRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    async getDMs() {
      try {
        let res = await api.getDirectMessages();
        this.transformAPIResponse(res.data.data);
      } catch (error) {
        this.handleError(error);
      }

      setTimeout(async () => {
        if (this.gotoprofile) {
          let profile = null;
          for (const dm of this.chats) {
            if (dm.id == this.gotoprofile) profile = dm;
          }

          if (profile) {
            this.selectDM(profile);
          } else {
            // get additional specially requested profile and emit that its selected
            try {
              await api.getSpecificDM(this.gotoprofile);
            } catch (error) {
              this.handleError(error);
            }
            try {
              let res = await api.getDirectMessages();
              await this.transformAPIResponse(res.data.data);
              for (const dm of this.chats) {
                if (dm.id == this.gotoprofile) profile = dm;
              }
              this.selectDM(profile);
            } catch (error) {
              this.handleError(error);
            }
          }
        }
        this.$emit("resetchatprop");
      }, 0);
    },
    async transformAPIResponse(arr) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        const el = arr[i];
        let dataFormat = {
          id: el.usr_id,
          read: el.msg_read,
          imageURL: await this.getImageUsrId(el.usr_id),
          online: el.online ? true : false,
          name: el.usr_firstname,
          lastname: el.usr_lastname,
          title: el.ust_name,
          lastMessageSender: el.lastMessageSender,
          lastMessage: el.msg_text,
          unseenMsgs: el.unseen_messages,
          rol_id: el.rol_id
        };
        newArr.push(dataFormat);
      }
      this.chats = newArr;
      this.filterPeople();
    },
    selectDM(msg) {
      // emits what DM was selected on user click
      if (msg) {
        this.$emit("selected", msg);
        this.$emit('getRolId',msg.rol_id);
      } 
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

$toolbar-height: 40px;
$padding-width: 20px;

.dm-list-wrap {
  height: calc(100% - 0px);
  width: calc(50% - 40px);
  padding: 10px $padding-width;
  &.mobile {
    height: calc(100% - 40px);
    width: 100%;
    box-sizing: border-box;
  }
}
.search-message-input {
  background: white;
  height: 30px;
  @include flex-start;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  border-radius: 100px;
  span {
    user-select: none;
    color: #bdbdbd;
    margin: 0 10px;
    font-size: 18px;
  }
  input {
    padding: 0;
    height: auto;
    box-shadow: none;
    width: 85%;
    border: none;
    color: rgb(99, 99, 99);
  }
  input::placeholder {
    color: #bdbdbd;
  }
  input:focus {
    outline: none;
  }
}

.list-wrap {
  height: calc(100% - 30px);
  overflow-y: scroll;
  user-select: none;
}
.list-item {
  cursor: pointer;
  user-select: none;
  @include flex-between;
  height: 80px;
  .dm-icon-wrap {
    @include flex-center;
    width: 80px;
    height: 80px;
    position: relative;
    .img-wrap {
      @include flex-center;
      width: 55px;
      height: 55px;
      border-radius: 50%;
      overflow: hidden;
      border: 0.5px rgba(0, 0, 0, 0.118) solid;
      position: relative;
      .frame {
        position: absolute;
      }
      img {
        height: 100%;
        max-width: none;
      }
    }
    .green-dot {
      position: absolute;
      width: 8px;
      height: 8px;
      left: 55px;
      top: 55px;
      border-radius: 50%;
      background-color: #69d200;
      // z-index: 99999;
    }
  }
  .dm-name-and-last-message {
    position: relative;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    height: 70px;
    width: calc(100% - 90px);
    overflow: hidden;
    .unseen-msg {
      position: absolute;
      @include flex-center();
      width: 21px;
      height: 21px;
      border-radius: 50%;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: #69d200;
      color: white;
      font-size: 12px;
    }
    .name-lastname {
      max-width: 100%;
      -webkit-line-clamp: 1;
      overflow: hidden;
      line-height: 20px;
      max-height: 20px;
      text-overflow: ellipsis;
      font-weight: 600;
      margin-bottom: 2px;
      .name-title {
        opacity: 0.5;
        font-weight: 300;
      }
    }
    .name-message {
      font-size: 13px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
</style>